export const INBOUND_TYPES_PERMISSIONS = {
  SHOW_DATA: 'show_inbound_types',
  CREATE_DATA: 'create_inbound_types',
  EDIT_DATA: 'edit_inbound_types',
  CHANGE_STATE_DATA: 'change_state_inbound_types',
  DELETE_DATA: 'delete_inbound_types',
  EXPORT_EXCEL: 'export_inbound_types',
  IMPORT_EXCEL: 'import_inbound_types',
} as const;

export const INBOUND_TYPES_PERMISSION_LIST = [
  INBOUND_TYPES_PERMISSIONS.SHOW_DATA,
  INBOUND_TYPES_PERMISSIONS.CREATE_DATA,
  INBOUND_TYPES_PERMISSIONS.EDIT_DATA,
  INBOUND_TYPES_PERMISSIONS.CHANGE_STATE_DATA,
  INBOUND_TYPES_PERMISSIONS.DELETE_DATA,
  INBOUND_TYPES_PERMISSIONS.EXPORT_EXCEL,
  INBOUND_TYPES_PERMISSIONS.IMPORT_EXCEL,
] as const;